export default "__VITE_ASSET__c8d846f2__"